import { render, staticRenderFns } from "./HourHeatMapChart.vue?vue&type=template&id=22d53aea"
import script from "./HourHeatMapChart.vue?vue&type=script&lang=js"
export * from "./HourHeatMapChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports